import Icon from '../components/Icon.vue'

Icon.register({"product-hunt":{"width":1792,"height":1792,"paths":[{"d":"M1150 762q0 56-39.5 95t-95.5 39h-253v-269h253q56 0 95.5 39.5t39.5 95.5zM1329 762q0-130-91.5-222t-222.5-92h-433v896h180v-269h253q130 0 222-91.5t92-221.5zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/product-hunt.js
// module id = 1003
// module chunks = 0